// extracted by mini-css-extract-plugin
export default {"villageChart":"TalukaChart_villageChart__wU5dX"};